import { waitForPageLoadAnalytics } from "./pageLoad";
import getWindow from "../utils/window";
import { getCommons, getGlobalEvars } from "./common";
import { setEvents, setLinkTrackEvents } from "./events";
import { getOOSProducts } from "../utils/product";

export const fireRecommendedOutfitsModalOpen = async ({ products }) => {
  if (!products || !products.length) {
    return;
  }

  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  const TRACKING_NAME = "recommendedOutfitsModalOpen";

  setEvents({
    events: [
      `event342=${products.length}`,
      `event343=${getOOSProducts(products).length}`,
    ],
    trackingName: TRACKING_NAME,
  });

  s.prop6 = "sfy cta bottom";

  s.tl(true, "o", "sfy - pop up page", {
    linkTrackVars: commons.setLinkTrackVars([...getGlobalEvars(), "prop6"]),
    linkTrackEvents: setLinkTrackEvents({ trackingName: TRACKING_NAME }),
  });
};

export const fireRecommendedOutfitsScrollToView = async () => {
  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  const TRACKING_NAME = "recommendedOutfitsCtaView";

  const events = ["event172"];
  setEvents({
    events,
    trackingName: TRACKING_NAME,
  });

  s.eVar106 = "styled for you|cta|impression";

  s.tl(true, "o", "styled for you content impression", {
    linkTrackVars: commons.setLinkTrackVars([...getGlobalEvars(), "eVar106"]),
    linkTrackEvents: setLinkTrackEvents({
      trackingName: TRACKING_NAME,
    }),
  });
};
